export const SEARCH_PARAM_ASSET_LENS_TAB = 'tab'
